import { render, staticRenderFns } from "./drawer-header.vue?vue&type=template&id=6b4396d9&scoped=true&"
import script from "./drawer-header.vue?vue&type=script&lang=js&"
export * from "./drawer-header.vue?vue&type=script&lang=js&"
import style0 from "./drawer-header.vue?vue&type=style&index=0&id=6b4396d9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4396d9",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
